// System Vietnamese translations
export const systemVi = {
  'add.ai.model': 'Thêm Mô Hình AI',
  'add.customer': 'Thêm Khách Hàng',
  'ai.model.configuration': 'Cấu Hình Mô Hình AI',
  'ai.model.created': 'Tạo mô hình AI thành công',
  'ai.model.deleted': 'Xóa mô hình AI thành công',
  'ai.model.selected': 'Chọn mô hình AI thành công',
  'ai.model.updated': 'Cập nhật mô hình AI thành công',
  'ai.models': 'Mô Hình AI',
  'available.districts': 'Quận/Huyện Có Sẵn',
  'confirm.delete.ai.model': 'Bạn có chắc chắn muốn xóa mô hình AI này không?',
  'customer': 'Khách Hàng',
  'customer.created.successfully': 'Tạo khách hàng thành công',
  'customer.deleted.successfully': 'Xóa khách hàng thành công',
  'customer.email': 'Email Khách Hàng',
  'customer.management': 'Quản Lý Khách Hàng',
  'customer.name': 'Tên Khách Hàng',
  'customer.phone': 'Số Điện Thoại Khách Hàng',
  'customer.updated.successfully': 'Cập nhật khách hàng thành công',
  'delete.customer.confirm': 'Bạn có chắc chắn muốn xóa khách hàng này không?',
  'document.type': 'Loại Tài Liệu',
  'edit.ai.model': 'Chỉnh Sửa Mô Hình AI',
  'edit.customer': 'Chỉnh Sửa Khách Hàng',
  'email': 'Email',
  'error.delete.failed': 'Không thể xóa cấu trúc phí',
  'error.fetch.failed': 'Không thể tải cấu trúc phí',
  'error.save.failed': 'Không thể lưu cấu trúc phí',
  'failed': 'Thất Bại',
  'failed.to.create.customer': 'Không thể tạo khách hàng',
  'failed.to.delete.customer': 'Không thể xóa khách hàng',
  'failed.to.delete.file': 'Xóa tệp thất bại',
  'failed.to.fetch.customers': 'Không thể tải danh sách khách hàng',
  'failed.to.fetch.history': 'Không thể tải lịch sử',
  'failed.to.fetch.settings': 'Không thể tải cài đặt',
  'failed.to.process.image': 'Xử lý hình ảnh thất bại',
  'failed.to.restore.record': 'Không thể khôi phục hồ sơ',
  'failed.to.save.settings': 'Không thể lưu cài đặt',
  'failed.to.update.customer': 'Không thể cập nhật khách hàng',
  'invalid.email': 'Định dạng email không hợp lệ',
  'login.failed': 'Đăng nhập thất bại',
  'no.ai.models.available': 'Không có mô hình AI nào',
  'no.data.available': 'Không có dữ liệu cho',
  'no.districts.available': 'Không có quận/huyện nào',
  'remaining.balance': 'Số Dư Còn Lại',
  'retry.failed': 'Thử lại thất bại',
  'save.settings': 'Lưu Cài Đặt',
  'select.documents': 'Chọn Tài Liệu (PDF, JPG, PNG)',
  'settings': 'Cài Đặt',
  'settings.saved.successfully': 'Lưu cài đặt thành công',
  'fuel.station.location': 'Vị Trí Trạm Xăng',
  'fuel.station.location.tooltip': 'Dùng để phát hiện điểm dừng đổ xăng nhằm tính toán hiệu suất nhiên liệu. Click chuột phải trạm xăng trên Google Maps để lấy tọa độ.',
  'fuel.station.lat': 'Vĩ độ (VD: 10.266595)',
  'fuel.station.lon': 'Kinh độ (VD: 106.359337)',
  'system': 'Hệ Thống',
  'system.data.management': 'Quản Lý Dữ Liệu Hệ Thống',
  'system.information': 'Thông Tin Hệ Thống',
  'vcomsat.journey.sync.description': 'Đồng bộ dữ liệu hành trình và điểm dừng từ hệ thống định vị GPS VCOMSAT cho tất cả phương tiện. Chọn khoảng thời gian để đồng bộ dữ liệu.',
  'vcomsat.journey.sync.failed': 'Đồng Bộ Hành Trình Thất Bại',
  'vcomsat.journey.sync.note': 'Đồng Bộ Dữ Liệu Hành Trình',
  'vcomsat.journey.sync.result': 'Kết Quả Đồng Bộ Hành Trình',
  'vcomsat.matched.count': 'Số Xe Khớp',
  'vcomsat.sync.failed': 'Đồng Bộ VCOMSAT Thất Bại',
  'vcomsat.sync.journey': 'Đồng Bộ Dữ Liệu Hành Trình',
  'vcomsat.sync.success': 'Đồng Bộ VCOMSAT Thành Công',
  'vcomsat.synced.count': 'Số Xe Đã Đồng Bộ',

  // OSM Preprocessing translations
  'model.purpose.telegram.chat': 'Chat Telegram',

  // Telegram
  'telegram.chat.model': 'Mô Hình AI Chat Telegram',
  'telegram.chat.model.active': 'Mô hình này xử lý phản hồi chat bot Telegram với công cụ MCP.',
  'telegram.chat.model.not.configured': 'Chưa chọn mô hình Chat Telegram',
  'telegram.chat.model.not.configured.desc': 'Thêm mô hình AI TelegramChat để kích hoạt phản hồi chat thông minh.',
  'telegram.chat.model.available': 'có sẵn',

  'osm.preprocessing': 'Tiền Xử Lý Dữ Liệu OSM',
  'osm.preprocessing.status': 'Trạng Thái Tiền Xử Lý',
  'osm.data.management': 'Quản Lý Dữ Liệu OSM',
  'osm.no.data': 'Chưa có dữ liệu OSM trong cơ sở dữ liệu',
  'osm.has.data': 'Dữ liệu OSM đã có sẵn',
  'osm.nodes': 'Nút',
  'osm.road.segments': 'Đoạn Đường',
  'osm.address.points': 'Điểm Địa Chỉ',
  'osm.boundaries': 'Ranh Giới Hành Chính',
  'osm.estimated.db.size': 'Kích Thước Cơ Sở Dữ Liệu Ước Tính',
  'osm.start.preprocessing': 'Bắt Đầu Tiền Xử Lý',
  'osm.clear.data': 'Xóa Dữ Liệu OSM',
  'osm.download.data': 'Tải Dữ Liệu OSM',
  'osm.preprocessing.in.progress': 'Đang tiền xử lý... Quá trình này có thể mất 15-30 phút.',
  'osm.preprocessing.complete': 'Tiền xử lý OSM hoàn tất thành công',
  'osm.preprocessing.failed': 'Tiền xử lý OSM thất bại',
  'osm.clear.confirm': 'Bạn có chắc chắn muốn xóa tất cả dữ liệu OSM không? Hành động này không thể hoàn tác.',
  'osm.clear.success': 'Xóa dữ liệu OSM thành công',
  'osm.clear.failed': 'Xóa dữ liệu OSM thất bại',
  'osm.download.confirm': 'Tải file vietnam-latest.osm.pbf (~500MB)? Quá trình này có thể mất vài phút.',
  'osm.download.success': 'Tải dữ liệu OSM thành công',
  'osm.download.failed': 'Tải dữ liệu OSM thất bại',
  'osm.preprocess.confirm': 'Bắt đầu tiền xử lý OSM? Quá trình này sẽ mất 15-30 phút và cần ~4GB RAM.',
  'osm.file.path': 'Đường Dẫn File OSM',
  'osm.clear.existing': 'Xóa Dữ Liệu Hiện Có',
  'osm.statistics': 'Thống Kê OSM',
  'osm.benefits.title': 'Lợi Ích Của Tiền Xử Lý',
  'osm.benefits.memory': 'Giảm 90% bộ nhớ sử dụng',
  'osm.benefits.startup': 'Khởi động nhanh hơn 95%',
  'osm.benefits.performance': 'Hiệu suất truy vấn tốt hơn',
};
